import { useEffect, useState } from "react";
import { FaCheckCircle, FaIdCard, FaUser } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import {
  useLocation,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Input,
  Row,
} from "reactstrap";
import { applyClassToCharacters, LoadingSpinner } from "../../constants/const";
import { ApiAhbab } from "../ahbab/ApiAhbab";
import { GetLanguageString } from "../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../helper/Method";
import { useTranslation } from "react-i18next";
import { ApiEvent } from "./ApiEvent";
import { IoAdd, IoCheckmark } from "react-icons/io5";
import AddAhbabModel from "../ahbab/AddAhbabModel";

const EventBarCodeAttendanceAhbab = ({ eventIdFromToken, applyMarginTop }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isAttendanceMarked, setIsAttendanceMarked] = useState(false);
  const [markingAttendanceSuccess, setMarkingAttendanceSuccess] = useState("");
  const [unMarkingAttendance, setUnMarkingAttendance] = useState(false);
  const [markingAttendanceError, setMarkingAttendanceError] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [scanStatus, setScanStatus] = useState("ready"); // 'ready', 'scanning', 'success', 'error'
  const [loading, setLoading] = useState(false);
  const [markingAttendance, setMarkingAttendance] = useState(false);
  const [callAddAhbabModel, setCallAddAhbabModel] = useState(false);
  const [habibId, setHabibId] = useState();
  const [habibData, setHabibData] = useState(null);
  const [error, setError] = useState("");
  const eventId = eventIdFromToken ? eventIdFromToken : location.state?.eventId;

  const handleInputChange = (e) => {
    let val = e.target.value.replace(/[^0-9]/g, "");
    setMobileNumber(val.slice(0, 11));
    setMarkingAttendanceError("");
    setMarkingAttendanceSuccess("");
    setError("");
    setIsAttendanceMarked(false);
  };

  const handleSearch = () => {
    if (mobileNumber.length !== 11) {
      setError("Please enter a valid 11-digit mobile number (03xxxxxxxxx).");
      return;
    }
    setMarkingAttendanceError("");
    setMarkingAttendanceSuccess("");
    setIsAttendanceMarked(false);
    setError("");
    setLoading(true);
    setHabibData(null);

    const formattedMobile = mobileNumber.startsWith("0")
      ? mobileNumber.substring(1)
      : mobileNumber;

    ApiAhbab()
      .GetSimilarAhbabByMobileNumberForEventAttendance(formattedMobile, eventId)
      .then((res) => {
        if (!res.data || res.data.length === 0) {
          setError("No Habib found with this mobile number.");
          setLoading(false);
          setMobileNumber("");
          return;
        }

        if (res.data[0].attendanceExists) {
          setScanStatus("ready");
          setError("Error: " + t("already_marked_attendance"));
        } else {
          setScanStatus("success");
        }

        setMobileNumber("");
        setHabibData(res.data[0]);
        setLoading(false);
      })
      .catch(() => {
        setMobileNumber("");
        setScanStatus("error");
        setError("An error occurred while searching. Please try again.");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (habibId) {
      handleMarkAttendance();
    }
    // eslint-disable-next-line
  }, [habibId]);

  const handleMarkAttendance = (e) => {
    if (e) e.preventDefault(); // only call preventDefault if e exists
    setLoading(true);
    setMarkingAttendance(true);
    setMarkingAttendanceError("");
    setMarkingAttendanceSuccess("");
    setIsAttendanceMarked(false);
    ApiEvent()
      .addeventparticipant({
        eventId: eventId,
        serialNumber: null,
        onTime: true,
        memberId: habibData?.id || habibId,
      })
      .then((res) => {
        if (res.data) {
          setLoading(false);
          setHabibData("");
          setMobileNumber("");
          setMarkingAttendanceError("");
          setScanStatus("ready");
          setIsAttendanceMarked(true);
          setMarkingAttendance(false);
          setMarkingAttendanceSuccess(
            GetSelectedLanguage() === "ur"
              ? res.data + " کی حاضری لگا دی گئی ہے"
              : "Attendance marked for " + res.data
          );
        }
      })
      .catch((err) => {
        setHabibData("");
        setMobileNumber("");
        setLoading(false);
        setMarkingAttendance(false);
        let serverMessage = "event_attendance_barcode_error_marking_attendance";
        let errorType = "event_attendance_barcode_error_marking_attendance";

        if (err.response) {
          if (err.response.data?.message) {
            serverMessage = err.response.data.message;
          } else if (typeof err.response.data === "string") {
            serverMessage = err.response.data;
          }
          if (err.response.data?.type) {
            errorType = err.response.data.type;
          } else if (typeof err.response.data === "string") {
            errorType = err.response.data;
          }
        }
        if (
          serverMessage.includes("already_marked_attendance") ||
          errorType.includes("already_marked_attendance")
        ) {
          setScanStatus("");
        } else {
          setScanStatus("error");
        }
        setMarkingAttendanceError(
          "Error: " + t("already_marked_attendance_habib")
        );

        if (errorType.includes("invalid_event_participant")) {
          setScanStatus("");
          setMarkingAttendanceError(
            GetSelectedLanguage() === "ur"
              ? +"یہ حبیب " +
                  serverMessage +
                  " اس اجتماع میں شامل ہونے کی اجازت نہیں رکھتا"
              : "This habib " + serverMessage + " is not allowed in this Ijtima"
          );
        }
      });
  };

  const deleteEventParticipant = (memberId) => {
    setLoading(true);
    setUnMarkingAttendance(true);
    setError("");
    ApiEvent()
      .deleteEventParticipant(memberId, eventId)
      .then((res) => {
        setLoading(false);
        setHabibData("");
        setError("");
        setScanStatus("ready");
        setIsAttendanceMarked(true);
        setUnMarkingAttendance(false);
        setMarkingAttendanceSuccess(
          GetSelectedLanguage() === "ur"
            ? "حاضری منسوخ کر دی گئی ہے۔"
            : "Attendance has been unmarked."
        );
      })
      .catch((err) => {
        setError(err.response.data);
        setLoading(false);
        setScanStatus("");
        setHabibData("");
        setUnMarkingAttendance(false);
      });
  };

  const getStatusColor = () => {
    switch (scanStatus) {
      case "scanning":
        return "text-primary";
      case "success":
        return "text-success";
      case "error":
        return "text-danger";
      default:
        return "text-muted";
    }
  };

  const getStatusIcon = () => {
    switch (scanStatus) {
      case "scanning":
        return <FaUser size={64} className="animate-pulse" />;
      case "success":
        return <FaCheckCircle size={64} className="animate-pulse" />;
      case "error":
        return <FaUser size={64} className="animate-pulse" />;
      default:
        return <FaUser size={64} className="animate-pulse" />;
    }
  };

  return (
    <div
      className={
        applyMarginTop
          ? "wrapper-custom wrapper wrapper-content animated fadeInRight"
          : ""
      }
    >
      {callAddAhbabModel && (
        <AddAhbabModel
          setCallAddAhbabModel={setCallAddAhbabModel}
          setHabibId={setHabibId}
          willSetHabibId={true}
          eventId={eventId}
        />
      )}
      <div className="panel panel-success">
        <div className="panel-heading">
          <Row>
            <Col md="9">
              <h4 className="m-0">
                <GetLanguageString props={"common_attendance"} />
              </h4>
            </Col>
            <Col md="3" className="text-end">
              <Button
                color="primary"
                size="sm"
                className={GetCustomStyles().btn_style}
                onClick={() => {
                  setCallAddAhbabModel(true);
                }}
              >
                <IoAdd
                  color="#f7f8f8ff"
                  size={18}
                  style={{ marginRight: 3, marginBottom: 1 }}
                />
                {<GetLanguageString props="ahbab_add" />}
              </Button>
            </Col>
          </Row>
        </div>

        <div className="panel-body">
          <Row>
            {/* Left Side — Search */}
            <Col
              md="6"
              className={
                GetSelectedLanguage() === "ur"
                  ? "border-start ps-md-4"
                  : "border-end pe-md-4"
              }
            >
              {!loading ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "300px",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  <div className={`display-4 mb-3 ${getStatusColor()}`}>
                    {getStatusIcon()}
                  </div>
                  <h2 className="mb-3" style={{ fontWeight: "600" }}>
                    {scanStatus === "scanning"
                      ? t("event_attendance_barcode_scanning")
                      : scanStatus === "success"
                      ? t("event_attendance_barcode_habib_verified")
                      : scanStatus === "error"
                      ? t("ahbab_habib_not_found")
                      : t("member_search_by_mobile_number")}
                  </h2>
                  <p className="text-muted">
                    {scanStatus === "ready"
                      ? ""
                      : scanStatus === "scanning"
                      ? t("event_attendance_barcode_reading")
                      : scanStatus === "success"
                      ? t("event_attendance_barcode_confirm_attendance")
                      : t("please_try_again")}
                  </p>
                  {scanStatus === "success" ? null : (
                    <div className="mt-3 w-100">
                      <Row className="justify-content-center">
                        <Col xs="12" sm="8" md="6" lg="5">
                          <Input
                            type="text"
                            autoFocus
                            value={mobileNumber}
                            onChange={handleInputChange}
                            onKeyDown={(e) =>
                              e.key === "Enter" && handleSearch()
                            }
                            placeholder="Enter Mobile Number (03xxxxxxxxx)"
                            className="text-center"
                            maxLength={11}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "300px", // adjust as needed
                    textAlign: "center",
                  }}
                >
                  <h2 className="mb-3" style={{ fontWeight: "600" }}>
                    <GetLanguageString
                      props={
                        markingAttendance
                          ? "event_attendance_barcode_marking_attendance"
                          : unMarkingAttendance
                          ? "event_attendance_barcode_unmarking_attendance"
                          : "event_attendance_barcode_fetching"
                      }
                    />
                  </h2>
                </div>
              )}
            </Col>

            {/* Right Side — Member Details */}
            <Col md="6" className="ps-md-4">
              {!loading ? (
                <>
                  {habibData ? (
                    <Card className="shadow-lg border-0 h-100">
                      <div className="card-header bg-success text-white py-3">
                        <div className="d-flex align-items-center">
                          <FaIdCard className="me-2" size={25} />
                          <CardTitle tag="h4" className="m-0">
                            <GetLanguageString props="ahbab_transfer_habib_habib_details" />
                          </CardTitle>
                        </div>
                      </div>

                      <CardBody className="p-4">
                        <h1 className="m-0 mb-3" style={{ fontWeight: 600 }}>
                          {applyClassToCharacters(habibData.habibName, "ur")}
                        </h1>

                        <div className="border-top pt-3">
                          {habibData?.address?.trim() && (
                            <Row className="mb-2">
                              <Col xs="2" className="text-muted">
                                <GetLanguageString props="ahbab_address" />{" "}
                                {" : "}
                              </Col>
                              <Col
                                xs="10"
                                className="fw-bold"
                                style={{ fontSize: 15 }}
                              >
                                {applyClassToCharacters(
                                  habibData.address,
                                  "ur"
                                )}
                              </Col>
                            </Row>
                          )}

                          <Row className="mb-2">
                            <Col xs="2" className="text-muted">
                              <GetLanguageString props="unit" /> {" : "}
                            </Col>
                            <Col
                              xs="10"
                              className="fw-bold ur"
                              style={{ fontSize: 15 }}
                            >
                              {habibData.unitName}
                            </Col>
                          </Row>
                          {habibData.associatedMember ? (
                            <Row className="mb-2">
                              <Col xs="2" className="text-muted">
                                <GetLanguageString props="ahbab_associated_member" />{" "}
                                {" : "}
                              </Col>
                              <Col
                                xs="10"
                                className="fw-bold"
                                style={{ fontSize: 15 }}
                              >
                                {applyClassToCharacters(
                                  habibData.associatedMember +
                                    " - " +
                                    habibData.associatedMemberRegNo,
                                  "ur"
                                )}
                              </Col>
                            </Row>
                          ) : null}
                        </div>
                      </CardBody>

                      <div className="card-footer bg-light py-2">
                        <Row>
                          <Col
                            xs="12"
                            className={
                              GetSelectedLanguage() === "ur"
                                ? "text-start"
                                : "text-end"
                            }
                          >
                            <Button
                              outline
                              color="danger"
                              onClick={() => {
                                setScanStatus("ready");
                                setMarkingAttendanceError("");
                                setMarkingAttendanceSuccess("");
                                setError("");
                                setIsAttendanceMarked(false);
                                setHabibData(null);
                                setMobileNumber("");
                              }}
                            >
                              <RxCross2
                                size={16}
                                style={{ marginBottom: 2, marginRight: 5 }}
                              />
                              <GetLanguageString props={"common_cancel"} />
                            </Button>{" "}
                            {habibData.attendanceExists ? null : (
                              <Button
                                outline
                                color="success"
                                onClick={handleMarkAttendance}
                              >
                                <IoCheckmark
                                  size={16}
                                  style={{ marginBottom: 2, marginRight: 5 }}
                                />
                                <GetLanguageString props={"common_confirm"} />
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100">
                      <FaIdCard size={64} className="text-muted mb-3" />
                      <h5 className="text-muted">
                        <GetLanguageString
                          props={"event_attendance_no_selected_habib"}
                        />
                      </h5>
                      <p className="text-muted text-center">
                        <GetLanguageString
                          props={
                            "event_attendance_select_habib_to_show_details"
                          }
                        />
                      </p>
                    </div>
                  )}
                </>
              ) : (
                LoadingSpinner()
              )}
            </Col>
          </Row>{" "}
          {markingAttendanceError && (
            <Alert color="danger" style={{ marginTop: "20px" }}>
              {applyClassToCharacters(markingAttendanceError, "ur")}
              {}
            </Alert>
          )}
          {isAttendanceMarked && (
            <Alert color="success" style={{ marginTop: "20px" }}>
              {applyClassToCharacters(markingAttendanceSuccess, "ur")}
            </Alert>
          )}
          {error && (
            <Alert
              color="danger"
              className="d-flex justify-content-between align-items-center p-3"
              style={{ marginTop: "20px" }}
            >
              <span>{applyClassToCharacters(error, "ur")}</span>
              {error.includes(
                "Attendance is already marked for this rafiq" ||
                  error.includes(" اس رفیق کی حاضری پہلے ہی لگ چکی ہے")
              ) ? (
                <Button
                  color="danger"
                  size="sm"
                  className="ms-3"
                  onClick={() => deleteEventParticipant(habibData.id)}
                  style={{ fontWeight: 500 }}
                >
                  ✕{" "}
                  <GetLanguageString
                    props={"events_attendance_unmark_attendance"}
                  />
                </Button>
              ) : null}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(EventBarCodeAttendanceAhbab);
